import { parseDateTimeOffsetToDate } from '../../../core/utils/Utils';
export class UserDataModel {
    constructor(data = {}) {
        this.CustomerRegistrationId = data.CustomerRegistrationId || null;
        this.UserId = data.UserId || null;
        // TOdo MasterId is not use
        this.MasterId = data.MasterId || null;
        this.IgmRegID = data.IgmRegID || null;
        this.IgmContent = data.IgmContent || null;
        this.IgmAuth = data.IgmAuth || null;
        this.NzwRegId = data.NzwRegId || null;
        this.NzwToken = data.NzwToken || null;
        this.NzwLid = data.NzwLid || null;
        this.Subscriptions = this.getSubscriptions(data);
        this.FullName = data.FullName || this.getFullName(); // must be after set subs
        this.LoginDate = data.LoginDate instanceof Date ? data.LoginDate : this.getDate(data.LoginDate);
        this.LastLogoutDate = data.LastLogoutDate instanceof Date ? data.LastLogoutDate : this.getDate(data.LastLogoutDate);
        this.EmailPreferences = data.EmailPreferences || null;
        this.DigitalAccess = data.DigitalAccess || null;
        this.DisplayName = data.DisplayName || data.name || data.nickname || '';
        this.AuthSystem = data.AuthSystem || '';
        this.AuthSystemId = data.AuthSystemId || '';
        this.UserState = data.UserState || data.userState || data.user_state || '';
        this.ZipCodes = data.ZipCodes || null;
        this.Email = data.Email || '';
        this.AuthProfile = data.AuthSystemData || null;
        this.AddDate = data.AddDate instanceof Date ? data.AddDate : this.getDate(data.AddDate);
    }
    updateAuthProfileData(profile) {
        this.UserId = profile.UserId;
        this.FullName = profile.FullName ? profile.FullName : this.FullName;
        this.AuthProfile = profile.AuthSystemData;
        this.Email = profile.Email ? profile.Email : this.Email;
    }
    getFullName() {
        const defaultName = 'User';
        if (this.Subscriptions) {
            let ownedSubscription = this.Subscriptions[0];
            return ownedSubscription.FirstName + ' ' + ownedSubscription.LastName || defaultName;
        }
        else {
            return defaultName;
        }
    }
    setAuthSystemInfo(authSystemId, authSystemName) {
        this.AuthSystemId = authSystemId;
        this.AuthSystem = authSystemName;
    }
    getSubscriptions(data) {
        let subs = [];
        if (data.Subscriptions) {
            for (let key in data.Subscriptions) {
                if (data.Subscriptions[key]) {
                    subs = subs.concat(Array.isArray(data.Subscriptions[key]) ? data.Subscriptions[key] : [data.Subscriptions[key]]);
                }
            }
        }
        return subs.length ? subs : null;
    }
    getDate(dateString) {
        if (!dateString) {
            return null;
        }
        let date;
        if (dateString.indexOf('/Date(') === 0) {
            date = parseDateTimeOffsetToDate(dateString);
        }
        else {
            date = new Date(dateString);
        }
        return isNaN(date.getTime()) ? null : date;
    }
}
